import React from 'react';
import { useSelector } from 'react-redux';
import WidgetInfoSettings from '../../settings_sidebar/WidgetInfoSettings.jsx';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import WidgetTitleSettings from '../../settings_sidebar/WidgetTitleSettings.jsx';
import ToggleSwitch from '../../../common/ToggleSwitch.jsx';
import commonStyles from '../base/CommonSettings.module.scss';

function AssignedTasksWidgetSettings({ widgetId }) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const projectFilterEnabled = useSelector(state => state.dashboard.widgets[widgetId].settings?.projectFilterEnabled ?? false);

    return (<>
        <hr />
        <CollapsibleSection title={I18n.t('content_settings')}>
            <fieldset>
                <WidgetTitleSettings widgetId={widgetId} />
                <WidgetInfoSettings widgetId={widgetId} />
                <div className={`${commonStyles['settings-section']} flex-dir-row justify-content-space-between mb-1`}>
                    <label>{I18n.t('project_filter_enabled')}</label>
                    <ToggleSwitch
                        name='project_filter_enabled'
                        isOn={projectFilterEnabled}
                        defaultIsOn={projectFilterEnabled}
                        handleToggle={() => setAttribute('settings.projectFilterEnabled', !projectFilterEnabled)}
                    />
                </div>
            </fieldset>
        </CollapsibleSection>
    </>);
};

export default AssignedTasksWidgetSettings;